<template>
  <div class="wrapper-full nibut">
    <el-container>
      <el-main :style="`height:${dispH - 155}px;weight:${dispW - 500}px;`" class="border-normal">
        <ImageBox
          :src="getImageURL(dispPhoto)"
          :width="dispW - 500"
          :height="dispH - 160"
          :focus="true"
          :colorHex="graphColor"
          :marking="getMarking()"
          :info="getInfo()"
          :proc="getProc()"
          :eyetype="getEyeType()"
          :currentUnit="graphUnit"
          :currentPhoto="dispPhoto"
          :curPage="currPage"
          @update="update"
          @focus="onImageFocus"
          @paper="selectPaper"
          :graphMode="graphMode"
        />
      </el-main>
      <el-aside
        width="500px"
        :style="`height:${dispH - 150}px;padding-top:5px;padding-bottom:5px;padding-right:5px`"
      >
        <div style="width: 500px; height: 70px; padding-left: 15px" class="border-bottom-thin">
          <el-form label-position="left" label-width="150px" style="font-size: 36px">
            <el-form-item
              :label="$t('langcfg.txtRemarks') + ':'"
              style="padding-right: 10px; height: 210px; font-size: 36px"
            >
              <el-input
                v-model="note"
                :style="`width: 300px; height: 210px;margin-top:${currentLanguage === 'de' ? '50px' : '0px'}`"
                resize="none"
                :row="14"
                @change="changeNote"
                @click.native.stop.prevent="handleClick"
                @touchend.native.stop.prevent="handleClick"
                type="textarea"
              />
            </el-form-item>
          </el-form>
        </div>
        <split-h class="split-h" :splitH="10"></split-h>
        <!-- <div class="aside-container" :style="`width:495px;height:${dispH-150}px;`">
          <ImageList :photos="photos" @changeShowItem="changeShowItem" :dispH=240/>
        </div> -->
      </el-aside>
    </el-container>
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../mixins";
import TrendChart from "./basic/TrendChart";
import ImageBox from "../../common/components/ImageBox";
import ImageItem from "./basic/ImageItem";
import ImageList from "./basic/ImageList";
import EVENTS from "../../bus";
import { cloneObj, getImageUrl } from "../../shared/utils";
let img1px = new Image();
img1px.onload = () => {};
export default {
  name: "ocularsurface",
  mixins: [Size, SubPageSize],
  data() {
    return {
      zoom: 1.5,
      isHugeMapVisible: false,
      currentid: 0,
      src: "",
      note: "",
      graphColor: "#00ff00",
      graphUnit: "mm",
      dispPhoto: {},
      currPage: "eyeredness",
      graphMode: "Select",
      needUserfulData: {},
      photos: [],
      osodStatus: "OD",
      currentLanguage: ""
    };
  },
  props: {
    record: Object,
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  mounted() {
    this.init(this.record);
    this.currentLanguage = window.settings.language;
    this.$bus.$emit(EVENTS.uploadingThirdyParty, "ocularsurface");
  },
  updated() {
    this.currentLanguage = window.settings.language;
  },
  components: {
    TrendChart,
    ImageItem,
    ImageList,
    ImageBox
  },
  methods: {
    handleClick() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.note, (value) => {
        self.note = value;
      });
    },
    init(Record) {
      this.curRecord = cloneObj(Record);
      this.needUserfulData[this.currentEye] =
        this.curRecord.content[`data${this.currentEye}`]["ocularsurface"];
      this.photos = new Array(4);
      this.showInterFaceOrToCamer();
    },
    showInterFaceOrToCamer() {
      this.dispPhoto = this.needUserfulData[this.currentEye].photos[0];
      this.photos = this.needUserfulData[this.currentEye].photos[0];

      this.note = this.needUserfulData[this.currentEye].note;
    },
    selectItem(id) {
      this.currentid = id;
    },
    getMarking: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.marking;
      } else {
        return undefined;
      }
    },
    update(marking) {},
    onImageFocus: function (dispid, paper) {
      this.currPaper = paper;
    },
    selectPaper: function (g, paper) {
      this.graph = g;
      this.currPaper = paper;
    },
    getInfo: function () {
      if (this.dispPhoto) {
        let info = {
          eyeType: "os",
          magnification: "16"
        };
        return info;
      } else {
        return undefined;
      }
    },
    getProc: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.imgproc;
      } else {
        return undefined;
      }
    },
    getEyeType: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.eyetype;
      } else {
        return undefined;
      }
    },
    showHugeMap() {
      this.isHugeMapVisible = !this.isHugeMapVisible;
    },
    getImageURL: function (file) {
      return getImageUrl((file || {}).filename, window.server, window.token);
    },
    changeShowItem: function (id) {
      this.dispPhoto = this.photos[id];
    },
    changeNote(e) {
      // 失焦之后就将现有的文字赋值给记录并上传
      this.curRecord.content[`data${this.currentEye}`]["ocularsurface"].note = this.note;
      this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
    }
  },
  watch: {
    currentEye: {
      handler(newType) {
        this.currentEye = newType;
        this.init(this.record);
      },
      immediate: true,
      deep: true
    },
    dispPhoto: {
      handler(newVal) {},
      immediate: true,
      deep: true
    },
    record: {
      handler(newRecord) {
        if (newRecord && newRecord.content) {
          this.init(newRecord);
        }
      },
      immediate: true,
      deep: true
    },
    note(newValue) {
      this.changeNote();
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 80px;
}
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.nibut {
  position: relative;
}
label {
  font-size: 23px;
}
.before::after {
  content: "\00A0\00A0\00A0\00A0";
}
.input-note {
  font-size: 23px;
  width: 95%;
  padding: 4px 10px;
  border-radius: 5px;
  border: none;
  outline: none;
}
/deep/.el-dialog {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
}
/deep/ .el-dialog__body {
  padding: 0 10px;
}
/deep/ .el-dialog__header {
  padding: 0;
}
#virtualKeyboard.ZH div.kbButton span {
  font-size: 18t !important;
}
/deep/ .el-form-item .el-form-item__label {
  font-size: 36px;
}
/deep/ .el-textarea textarea {
  font-size: 32px;
  height: 174px;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/Ocularsurface.vue